import * as CONFIG from './config';


exports.geteSignature = function (id) {
    // console.log("geteSignature==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/esignature/esignatureDetails' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.geteSignatureList = function (id) {
    // console.log("geteSignatureList==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/esignature/esignatureListForAdmin' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addeSignature = function (objModel) {
    // console.log("addeSignature==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/esignature/createEsignature', objModel)
            .then(function (response) {
                // console.log('addeSignature succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addeSignature err==>',err);
                reject(err);
            });
    });
}

exports.updateeSignature = function (objModel) {
    // console.log("updateeSignature==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/esignature/updateEsignature', objModel)
            .then(function (response) {
                // console.log('updateeSignature succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateeSignature err==>',err);
                reject(err);
            });
    });
}

exports.updateExistingFile = function (id,objModel) {
    // console.log("updateeSignature==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/esignature/updateExistFile/'+id, objModel)
            .then(function (response) {
                // console.log('updateeSignature succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateeSignature err==>',err);
                reject(err);
            });
    });
}

exports.deleteeSignature = function (id) {
    // console.log("deleteeSignature==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/esignature/deleteEsignature/'+id)
            .then(function (response) {
                // console.log('deleteeSignature succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteeSignature err==>',err);
                reject(err);
            });
    });
}



// WEBPACK FOOTER //
// ./api/esignaturedetails.js